import { render, staticRenderFns } from "./BecomeInstructor.vue?vue&type=template&id=315bec08"
import script from "./BecomeInstructor.vue?vue&type=script&lang=js"
export * from "./BecomeInstructor.vue?vue&type=script&lang=js"
import style0 from "./BecomeInstructor.vue?vue&type=style&index=0&id=315bec08&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports